import { FC } from 'react';
import { GenericError } from './GenericError';

export const NotFound: FC = () => {
  return <GenericError title="Página no disponible" description="No se pudo encontrar la página requerida." />;
};